export const RETRY = {
  maxRetries: 1,
  retryDelayMs: 300,
  minAttemptMs: 1000,
};

const RETRYABLE_STATUSES = [502, 503, 504];

export function retryDecision(failure, state) {
  const no = { retry: false, delayMs: 0 };
  if (!failure || state.retriesDone >= RETRY.maxRetries) return no;
  const retryable =
    failure.type === 'network' || (failure.type === 'http' && RETRYABLE_STATUSES.indexOf(failure.status) !== -1);
  if (!retryable) return no;
  const delayMs = state.noPause ? 0 : RETRY.retryDelayMs;
  if (!(state.remainingMs - delayMs >= RETRY.minAttemptMs)) return no;
  return { retry: true, delayMs: delayMs };
}

export function attemptReason(failure) {
  if (failure.type === 'http') return 'http_' + failure.status;
  return failure.type;
}

function isSet(value) {
  return value !== undefined && value !== null;
}

export function priorAttemptHeader(failure) {
  const elapsed = isSet(failure.elapsed_ms) ? failure.elapsed_ms : 0;
  const progress = isSet(failure.first_progress_ms) ? failure.first_progress_ms : '-';
  return (attemptReason(failure) + ';' + elapsed + ';' + progress).slice(0, 64);
}

export function budgetRemaining(startedAt, now, timeoutMs) {
  if (!(timeoutMs > 0)) return Infinity;
  return timeoutMs - (now - startedAt);
}
